import { IPromoCardProps } from "@/domains/promotion/types";
import styles from "./index.module.scss";
import { useCallback } from "react";
import { useTranslations } from "next-intl";

import { PUBLIC_IMAGE_URL } from "@/network/http-config";

export default function PromoCard({
  promo,
  promoId,
  onActivePromo,
  onMoreDetail,
}: IPromoCardProps) {
  const tPromo = useTranslations("AuthRegistrationPromo");

  const handleActivePromo = useCallback(
    (value: string) => {
      onActivePromo(value !== promoId ? value : null);
    },
    [promoId, onActivePromo],
  );

  return (
    <>
      <div className={styles.bonus}>
        <div className={styles.bonus__title}>{promo.title}</div>
        <div className={styles.bonus__content}>
          <div className={styles.bonus__img_wrapper}>
            <img
              className={`${styles.bonus__img} ${promoId === promo.id && styles.active}`}
              src={`${PUBLIC_IMAGE_URL}${promo.imageSmall || "uploads/promotions/bonus.webp"}`}
              width={132}
              height={132}
              alt="bonus"
            />
            {promoId === promo.id && (
              <span className={styles.bonus__status}>{tPromo("enable")}</span>
            )}
          </div>

          <div className={styles.bonus__properties}>
            <div className={styles.bonus__roperties_item}>
              <div className={styles.bonus__properties_title}>{tPromo("maxAmount")}</div>
              <div className={styles.bonus__properties_value}>
                {promo.maxBonus}&nbsp;
                <span className={styles.bonus__properties_currecy}>USDT</span>
              </div>
            </div>

            <div className={styles.bonus__roperties}>
              <div className={styles.bonus__roperties_item}>
                <div className={styles.bonus__properties_title}>{tPromo("minAmount")}</div>
                <div className={styles.bonus__properties_value}>
                  {promo.minDeposit}&nbsp;
                  <span className={styles.bonus__properties_currecy}>USDT</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.bonus__buttons}>
          <button
            className={`${styles.bonus__btn} ${styles.bonus__btn_info}`}
            onClick={() => onMoreDetail(promo)}
          >
            {tPromo("more")}
          </button>
          <button
            className={`${styles.bonus__btn} ${styles.bonus__btn_accent} ${promoId === promo.id && styles.active}`}
            onClick={() => handleActivePromo(promo.id)}
          >
            {promoId === promo.id ? tPromo("cancel") : tPromo("apply")}
          </button>
        </div>
      </div>
    </>
  );
}
